import { lazy } from 'react';
import LamanteShell from 'src/components/site/shells/LamanteShell';
import { ROUTE_COFFEEHOUSE_RIGA, ROUTE_COFFEEHOUSE_VOUCHER_CONFIRMED } from 'src/config/routes';
import { coreSiteRoutes } from 'src/config/sites/coreRoutes';
import { createModuleInit } from './moduleInit';
import { SiteDefinition } from './SiteDefinition';

const CoffeeHouseRigaRoutes = lazy(() => import('src/pages/coffeeHouseRiga/CoffeeHouseRigaRoutes'));
const CoffeeHouseVoucherConfirmedPage = lazy(() => import('src/pages/coffeeHouseRiga/CoffeeHouseVoucherConfirmedPage'));

const lamanteSite: SiteDefinition = {
    id: 'lamante',
    label: "L'Amante Classic",
    description: 'Primary customer experience with full navigation and business logic.',
    routes: [
        {
            key: 'coffeehouse-riga',
            route: ROUTE_COFFEEHOUSE_RIGA,
            component: CoffeeHouseRigaRoutes,
        },
        {
            key: 'coffeehouse-voucher-confirmed',
            route: ROUTE_COFFEEHOUSE_VOUCHER_CONFIRMED,
            component: CoffeeHouseVoucherConfirmedPage,
        },
        ...coreSiteRoutes,
    ],
    shell: LamanteShell,
    init: createModuleInit(),
};

export default lamanteSite;
